// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchTeam_root__2EZk2","image":"MatchTeam_image__Zh5p9","unknownLogo":"MatchTeam_unknownLogo__ravfO","name":"MatchTeam_name__zd8FO"};